import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=b7931b12&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=b7931b12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7931b12"

export default script